import { useState, useEffect } from "react";
import axios from "axios";

import { useAtom } from "jotai";
import { gbState } from "../../../../components/shared/GlobalState";

const TotalEnrolledFamiliesComponent = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  //Error Logging Service
  const [{ errorLogApi, user }] = useAtom(gbState);

  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/family/${user.church_id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then(function (response) {
          setData(response.data.families);
          setIsLoading(false);
        })
        .catch(function (err) {
          console.log("error api call ", err);
          setIsLoading(false);
        });
    };
    getDataFromServer();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      {data?.length} {data?.length === 1 ? "Family" : "Families"}
      {/* {JSON.stringify(data[0])} */}
    </div>
  );
};

export default TotalEnrolledFamiliesComponent;
